module.exports = __webpack_public_path__ + "img/4.b08b7e07.png";